export abstract class ObjectUtils {
  /**
   * Recursively removes "falsy" entries from an object in place.
   * "Falsy" entries are defined as:
   * - Strings that are empty after trimming.
   * - Numbers that are NaN or less than 0.
   * - Arrays with a length of 0.
   * The function operates recursively on nested objects.
   *
   * @param obj The object from which to remove falsy entries. This object is modified directly.
   */
  public static removeFalsyEntries(obj: Record<string, any>): void {
    if (!obj) return;

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (value === null || value === undefined) delete obj[key];

      if (typeof value === 'object' && !Array.isArray(value) && !!value) this.removeFalsyEntries(value);

      if (typeof value === 'string' && value.trim() === '') delete obj[key];

      if (typeof value === 'number' && (isNaN(value) || value < 0)) delete obj[key];

      if (Array.isArray(value) && value.length === 0) delete obj[key];
    });
  }
}
